/** @jsx jsx **/
import { jsx, SxStyleProp } from 'theme-ui'
import React, { FC, SVGProps } from 'react'
import { Maybe } from '~/@types/models'

type Props = SVGProps<SVGSVGElement> & {
  color?: string
  sxPropsSvg?: SxStyleProp
  left?: boolean
  hideCircle?: boolean
  direction?: 'up' | 'down' | 'left' | 'right'
}

const rotate = (direction: Maybe<Pick<Props, 'direction'>>) => {
  switch (direction) {
    case 'down':
      return `rotate(90deg)`
    case 'left':
      return `rotate(180deg)`
    case 'up':
      return `rotate(-90deg)`
    default:
      return 'none'
  }
}

const GatorArrow: FC<Props> = ({ color = 'black', sxPropsSvg, direction = 'right' }) => {
  return (
    <svg
      sx={{
        transform: rotate(direction),
        ...sxPropsSvg,
      }}
      width="15"
      height="25"
      viewBox="0 0 15 25"
      fill="none"
    >
      <path d="M2 2L12 12.5L2 23" stroke="black" strokeWidth="3" />
    </svg>
  )
}

export default React.memo(GatorArrow)
